/**
 * 未实现菜单的统一占位页（与 `admin-menu-tree.tsx` 中无对应页面的路由配套）。
 */
import { Empty } from 'antd';
import { useLocation } from 'react-router-dom';

export function PlaceholderPage() {
  const { pathname } = useLocation();
  return (
    <div style={{ padding: 24 }}>
      <Empty description={`页面「${pathname}」开发中，敬请期待。`} />
    </div>
  );
}
